import { useRecoilCallback } from 'recoil';
export const useRecoilCurrentGetPromise = () => useRecoilCallback(({ snapshot: { getPromise } }) => getPromise, []);
export const useRecoilCurrentGetLoadable = () => useRecoilCallback(({ snapshot: { getLoadable } }) => getLoadable, []);
export const useRecoilCurrentSnap = () => useRecoilCallback(({ snapshot }) => () => snapshot, []);
export const useRecoilCurrentSet = () => useRecoilCallback(({ set }) => set, []);
export const useRecoilCurrentReset = () => useRecoilCallback(({ reset }) => reset, []);
export const useRecoilCurrentRefresh = () => useRecoilCallback(({ refresh }) => refresh, []);
export const useRecoilCurrentGet = useRecoilCurrentGetPromise;
//# sourceMappingURL=recoilStore.js.map